// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3rw6k","row":"Node_row__2LaOL","label":"Node_label__3Zzp2","footer":"Node_footer__kS2xY"};